export const BASKETITEMID = 'basketitemid';
export const ACTION = 'action';
export const getCurrentItemId = (search?: string) => {
  const urlParams = new URLSearchParams(search ?? window.location.search);
  return urlParams.get(BASKETITEMID);
};
export const getBasketAction = (search?: string) => {
  const urlParams = new URLSearchParams(search ?? window.location.search);
  return urlParams.get(ACTION);
};
